export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-Ver-1-07-4.146066d2.jpg";